import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';
import { Types, CadastroAutorizacaoEspecialRequest } from './types';

// ACTIONS
import {
	cadastroAutorizacaoEspecialSuccess,
	cadastroAutorizacaoEspecialFailure,
} from './actions';

function* cadastroAutorizacaoEspecialRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastroAutorizacaoEspecialRequest } = request;

	const { usuario, ...body } = payload;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_IIRGD_BU_PPT,
		'autorizacao-especial',
		body,
		usuario,
	);

	if (response.status === 200) {
		yield put(
			cadastroAutorizacaoEspecialSuccess({ response, request: payload }),
		);
	} else if (response.error) {
		yield put(cadastroAutorizacaoEspecialFailure());
	}
}

export default all([
	takeLatest(
		Types.CADASTRO_AUTORIZACAO_ESPECIAL_REQUEST,
		cadastroAutorizacaoEspecialRequest,
	),
]);
